var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "toastModal",
      attrs: {
        id: _vm.modalId,
        "hide-header": "",
        "hide-footer": "",
        "hide-header-close": false,
        "no-close-on-backdrop": false,
        "no-close-on-esc": false,
        centered: "",
        size: "md",
        "content-class": "copy-result-toast-modal",
      },
      on: {
        hidden: function ($event) {
          return _vm.$emit("closed")
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "toast-content" },
        [
          _vm.isError
            ? _c(
                "div",
                { staticClass: "toast-icon-wrapper" },
                [
                  _c("b-icon", {
                    staticClass: "toast-icon-x-circle",
                    attrs: { icon: "x-circle" },
                  }),
                ],
                1
              )
            : _vm.isWarning
            ? _c(
                "div",
                { staticClass: "toast-icon-circle-warning" },
                [
                  _c("b-icon", {
                    staticClass: "toast-icon-exclamation",
                    attrs: { icon: "exclamation-lg" },
                  }),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "toast-icon-circle-success" },
                [
                  _c("b-icon", {
                    staticClass: "toast-icon-check2",
                    attrs: { icon: "check2" },
                  }),
                ],
                1
              ),
          _c("div", { staticClass: "toast-title" }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
          _c("div", { staticClass: "toast-message" }, [
            _vm._v(_vm._s(_vm.message)),
          ]),
          _c(
            "b-button",
            {
              staticClass: "toast-ok-btn",
              attrs: { variant: "primary" },
              on: { click: _vm.close },
            },
            [_vm._v(" " + _vm._s(_vm.$t("ok")) + " ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }